import { View } from 'react-native';

import { cn } from '@/components/ui/cn';
import { ProgressBar } from '@/components/ui/ProgressBar';
import { Text } from '@/components/ui/Text';

export interface UsageMeterProps {
  label: string;
  used: number;
  limit: number;
  tone?: 'default' | 'ink';
  className?: string;
}

/** Labeled usage bar — "CHECKLISTS 1 / 2". */
export function UsageMeter({
  label,
  used,
  limit,
  tone = 'default',
  className,
}: UsageMeterProps) {
  const textCls = tone === 'ink' ? 'text-faint' : 'text-muted';
  return (
    <View className={cn('gap-1.5', className)}>
      <View className="flex-row items-center justify-between">
        <Text
          variant="none"
          className={cn('font-accent text-xs uppercase tracking-[0.12em]', textCls)}
        >
          {label}
        </Text>
        <Text variant="none" className={cn('font-accent text-xs', textCls)}>
          {used} / {limit}
        </Text>
      </View>
      <ProgressBar value={used} total={limit} />
    </View>
  );
}
